<ch-breadcrumb [parts]="breadcrumb" (goTo)="(null)"></ch-breadcrumb>

<div class="card">
  <div class="card-header">
    {{ pageTitle }}
  </div>
  <div class="card-block">
    <div class="new-admin-redirect-container">
      <h3 style="font-size: 2.5rem">This feature exists only in the new admin portal</h3>
      <button
        class="btn btn-primary btn-lg redirect-button"
        (click)="navigateToNewAdmin()"
      >
        Check it out
        <i class="fa-external-link fa" aria-hidden="true"></i>
      </button>
    </div>
  </div>
</div>




// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/new-admin-redirect/new-admin-redirect.component.html